import { initComments } from "crosstalk-comments-livechat-sdk";
export function autoInitComments() {
    const commentDivs = document.querySelectorAll('div[data-crosstalk-comments]');
    const commentEmbeds = [];
    commentDivs.forEach(commentsDiv => {
        const config = {
            wp: commentsDiv.dataset.wp,
            url: commentsDiv.dataset.url || "",
            pageID: commentsDiv.dataset.pageId || "",
            theme: commentsDiv.dataset.theme || "light",
            reactions: commentsDiv.dataset.reactions === "true" ? true : false,
            locale: commentsDiv.dataset.lang || "en"
        };
        const instance = initComments(commentsDiv, config);
        if (instance)
            commentEmbeds.push(instance);
    });
    return commentEmbeds;
}
